import {ReactNode} from 'react'
import {useAtomValue, useSetAtom} from 'jotai'
import {currentLendingUserState, currentUserState} from '@frnt/base/atoms'
import {useLendingServiceQuery} from '../lending-service-provider'

interface LendingUserData {
  id: string
  is_organization_manager?: boolean
  is_borrower?: boolean
  is_lender?: boolean
  scope?: string[]
  hasWritePermissions?: boolean
}

interface CurrentLendingUserProviderProps {
  children: ReactNode
}

export const CurrentLendingUserProvider = ({children}: CurrentLendingUserProviderProps) => {
  const currentUser = useAtomValue(currentUserState)
  const setCurrentLendingUser = useSetAtom(currentLendingUserState)

  useLendingServiceQuery({
    path: '/accounts/me',
    enabled: !!currentUser,
    onSuccess: (data: LendingUserData) => {
      setCurrentLendingUser(data)
    },
    onError: () => {
      // 401 is expected for users without lending access
    }
  })

  return children
}
